import { defineComponent as _defineComponent } from 'vue'
import RmpAlertsSnackbar from "@rmp/core/components/alerts/RmpAlertsSnackbar.vue";
import { useAlertsStore } from "@rmp/core/stores/alerts";
import { storeToRefs } from "pinia";

interface Props {
	substractionWidth?: number | string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RmpAlerts',
  props: {
    substractionWidth: { default: 234 }
  },
  setup(__props: any) {




const useStore = useAlertsStore;
const store = useStore();
const { removeErrorAlert: onCloseErrorAlert, removeInfoAlert: onCloseInfoAlert, removeSuccessAlert: onCloseSuccessAlert } = useStore();

const { errorAlerts, infoAlerts, successAlerts } = storeToRefs(store);

return { __sfc: true,useStore, store, onCloseErrorAlert, onCloseInfoAlert, onCloseSuccessAlert, errorAlerts, infoAlerts, successAlerts, RmpAlertsSnackbar }
}

})